// extracted by mini-css-extract-plugin
module.exports = {"descriptionContent":"descriptionContent__2B7fL","descriptionTooltip":"descriptionTooltip__J1lwL"};